import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export enum TipoVisualizacaoIndicadores {
  Atualizacao = 1,
  Temperatura = 2,
  Etapa = 3,
}

export interface IndicadoresConsolidadosRequest {
  TipoVisualizacao: TipoVisualizacaoIndicadores;
  PaginaAtual?: number;
  TotalItensRetorno?: number;
  PalavraChave?: string;
  IdCorretor?: string[];
  IdEquipe?: string[];
  IdUsuarioGerente?: string[];
  IdUsuarioSuperintendente?: string[];
  enabled?: boolean;
}

export interface IndicadoresCorretor {
  idCorretor?: string;
  idCorretor365?: string;
  urlFoto?: string | null;
  apelido?: string;
  nome?: string;
  qtdLeads?: number;
  quantidadeLeads?: number;
  totalLeads?: number;
  indicadores: Record<string, number>;
}

export interface IndicadoresConsolidadosResponse {
  consolidados: Record<string, number>;
  corretores: IndicadoresCorretor[];
  totalRegistros: number;
  paginaAtual: number;
  totalPaginas: number;
}

const getParams = (props: IndicadoresConsolidadosRequest) => {
  const params = new URLSearchParams();

  params.append("TipoVisualizacao", String(props.TipoVisualizacao));
  params.append("PaginaAtual", String(props.PaginaAtual || 1));
  params.append("TotalItensRetorno", String(props.TotalItensRetorno || 10));

  if (props.PalavraChave) params.append("PalavraChave", props.PalavraChave);
  props.IdCorretor?.forEach((id) => params.append("IdCorretor", id));
  props.IdEquipe?.forEach((id) => params.append("IdEquipe", id));
  props.IdUsuarioGerente?.forEach((id) =>
    params.append("IdUsuarioGerente", id)
  );
  props.IdUsuarioSuperintendente?.forEach((id) =>
    params.append("IdUsuarioSuperintendente", id)
  );

  return params.toString();
};

export function useIndicadoresConsolidados(
  props: IndicadoresConsolidadosRequest & QueryGlobalInterface
) {
  const fetchData = async (): Promise<IndicadoresConsolidadosResponse> => {
    const response = await instance.get(
      `${leadsWebEnviroment}/commom/leads/indicadores-consolidados/v1?${getParams(
        props
      )}`
    );

    const payload = response?.data?.data || response?.data;

    return {
      consolidados: payload?.consolidados || {},
      corretores: payload?.corretores || [],
      totalRegistros: payload?.totalRegistros || 0,
      paginaAtual: payload?.paginaAtual || 1,
      totalPaginas: payload?.totalPaginas || 1,
    };
  };

  return useQuery({
    queryFn: fetchData,
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled ?? true,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar indicadores consolidados. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
}
